import { createFieldMap } from '@tanstack/react-form'

import { useFlag } from '~/hooks/useFlag'

import { withFieldGroup } from '../../Form/formHooks'
import { FormSectionWrapper, FormSectionWrapperProps } from '../../Form/FormWrapper'
import { SurgeryTypeFormSelect } from '../../Surgeons/Form/SurgeryTypeFormSelect'
import { defaultFormValues } from './formState'
import { LocationStaffingConfigFields } from './LocationStaffingConfigFields'

const defaultValues = defaultFormValues.activeProfile

const fieldMap = createFieldMap(defaultValues)

type LocationProfileFieldsProps = {
    roomCodeLabel: string
    size?: FormSectionWrapperProps['size']
}
const defaultProps: LocationProfileFieldsProps = {
    roomCodeLabel: '',
    size: 'default',
}
export const LocationProfileFields = withFieldGroup({
    defaultValues,
    props: defaultProps,
    render: function Render({ group, roomCodeLabel, size: sectionVariant }) {
        const isExpertEnabled = useFlag('hospital_configuration_expert')
        return (
            <>
                <FormSectionWrapper
                    title={`Hva kan skje på stuen${sectionVariant === 'compact' ? ' i denne perioden?' : '?'}`}
                    description="Viser hva slags operasjonskategorier og typer som kan skje på stuen."
                    size={sectionVariant}
                >
                    <group.AppField name="surgeryTypeGroups">
                        {field => (
                            <SurgeryTypeFormSelect
                                label={roomCodeLabel}
                                value={field.state.value}
                                onChange={field.handleChange}
                                errors={field.state.meta.errors}
                            />
                        )}
                    </group.AppField>
                </FormSectionWrapper>

                {isExpertEnabled && <LocationStaffingConfigFields form={group} fields={fieldMap} size={sectionVariant} />}
            </>
        )
    },
})
